import { DeleteRowConfirmationDialog } from "@/components/ax/dataTable/DeleteRowConfirmationDialog";
import { HospitalityMenuCategory, HospitalityMenuCategoryItem } from "@/lib/types";
import { deleteHospitalityMenuCategoryItem } from "@/sideEffects/api";
import { useQueryClient, useMutation } from "@tanstack/react-query";

interface Props {
  category: HospitalityMenuCategory;
  categoryItem: HospitalityMenuCategoryItem;
}

export const DeleteHospitalityMenuCategoryItemDialog: React.FC<Props> = ({ category, categoryItem }) => {
  const queryClient = useQueryClient();
  const deleteHospitalityMenuCategoryItemMutation = useMutation({
    mutationFn: () => deleteHospitalityMenuCategoryItem(category.hMenu_Id, categoryItem.id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getHospitalityMenuCategoryItem"],
      });
    },
  });

  return (
    <DeleteRowConfirmationDialog
      onConfirmDelete={() => deleteHospitalityMenuCategoryItemMutation.mutate()}
      isLoading={deleteHospitalityMenuCategoryItemMutation.isPending}
      type="iconOnly"
    />
  );
};
